import React, { useState, useEffect, useRef } from "react";
import { Accordion, Button, Container, Modal } from "react-bootstrap";
import Fliter from "../../assets/dust/fliter.svg";
import LodaingImage from "../../assets/images/loader.gif";
import {useLocation, useParams } from "react-router-dom";
import {clinicDistance, doctorAvailability, doctorImmediateAvailability, getHospitals, indianCities} from "../../actions/get-calls";
import { specialityInfoById } from "../../actions/get-calls";
import Doctors from "./doctors";
import {doctorAvailabilityByFilter} from "../../actions/post-call";
import {APP_SUB_FOLDER, dateFormatIntoDDMMYYYY, DefaultMetaTag, Domain} from "../../constants/app-constants";
import BreadcrumbWithUrl from "../../component/breadcrumb/breadcrumb-with-url";
import SearchTextWidget from "../../component/search/search-text-widget";
import FilterDoctorModal from "./FilterDoctorModal";
import LodingComponent from "../../component/loding";
import Helmet_SEO_META from "../../component/seo_meta";
import { getMetaData } from "../../actions/cms-api-handlers";

export default function ConsultDoctor() {
  const listInnerRef = useRef();

  const { hospitalName, Id, sId } = useParams();
  const [filterModal, setFilterModal] = useState(false);
  const [doctor, setDoctor] = useState([]);
  const [allDoctors, setAllDoctors] = useState([]);
  const [specialInfo, setSpecialInfo] = useState();
  const [consultType, setConsultType] = useState("0");

  const [keyword, setKeyword] = useState("");
  const [allDistances, setAllDistances] = useState(null);
  const [allCities, setAllCities] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [currentCityPage, setCurrentCityPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [distance, setDistance] = useState(0);
  const [dateType, setDateType] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [gender, setGender] = useState(0);
  const [specialityName, setSpecialityname] = useState();
  const [availabilityType, setAvailibilityType] = useState("");
  const [filterApplied, setFilterApplied] = useState(false);
  const location = useLocation();
  const [hospitalInfo, setHospitalInfo] = useState(null);
  const [tempKeyword, setTempKeyoword] = useState('');
  const [getSeoMata, setGetSeoMata]=useState("")
  const pageURL = window.location.origin + window.location.pathname;
  const [SEO_META, setSEO_META]=useState({
    title: DefaultMetaTag.title,
    description: DefaultMetaTag.description,
    keywords:DefaultMetaTag.keyword,
    pageURL: pageURL
  })
  useEffect(() => {
    const url =    Domain + location.pathname;
    getMetaData(url).then(function (response) {
      setGetSeoMata(response.data) 
  })
  .catch(function (err) {
  });  
  }, []);
  useEffect(() => {   
    if(getSeoMata && getSeoMata?.status == true){
            setSEO_META({
              title: getSeoMata.data[0].title,
              description: getSeoMata.data[0].description,
              keywords: getSeoMata.data[0].keyword,
              pageURL: pageURL
          })
    }
  }, [getSeoMata])
  const searchButtonClick=()=>{
    if(keyword.length>3){
      setTempKeyoword(keyword)
    }else if(keyword.length==0){
      setTempKeyoword(keyword)
    }
  }



  useEffect(() => {
    getHospitals(Id)
      .then(function (response) {
        let res = response.data;
        setHospitalInfo(res.hospital);
      })
      .catch(function () {});
  }, []);
  
  useEffect(async () => {
    getDoctors();

    const specials = await specialityInfoById(sId);
    setSpecialInfo(specials.data);

    setSpecialityname(specials.data.speciality.name);
    const distanceData = await clinicDistance();
    if (distanceData) {
      setAllDistances(distanceData.data.distance);
    }
  }, []);

  useEffect(async () => {
    if (keyword.length < 3) return false;
    getDoctors();
  }, [keyword]);
  
  useEffect(() => {
    if (keyword.length === 0) {
      getDoctors();
    }
  }, [keyword]);
  
  function getDoctors() {
    setEarlySlots(false)
    setLoading(true);
    const delayDebounceFn = setTimeout(async () => {
     
      const doctors = await doctorAvailability(
        sId,
        Id,
        keyword.length >= 3 ? keyword : ""
      );
      //  setDoctor(doctors.data.doctors);
      // setAllDoctors(doctors.data.doctors);

       const doctorsData = [...doctors.data.doctors].sort((a, b) => 
       {
         return (a.availability === null)-(b.availability === null) || -(a.availability>b.availability)||+(a.availability<b.availability)
       }
       );
      setDoctor(doctorsData);
      setAllDoctors(doctorsData);

      setLoading(false);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }
     
  useEffect(async () => {
    if (filterModal) {
      getCities();
    } else {
      setAllCities([]);
      setHasMore(true);
      setCurrentCityPage(1);
    }
  }, [filterModal]);

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (scrollTop + clientHeight === scrollHeight) {
        getCities();
      }
    }
  };

  async function getCities() {
    if (currentCityPage && hasMore) {
      const cityList = await indianCities(1, currentCityPage);

      if (cityList && cityList.data) {
        setAllCities([...allCities, ...cityList.data.cities]);
        if (cityList.data.pagination.links.next) {
          let cPage = currentCityPage + 1;
          setCurrentCityPage(cPage);
          setHasMore(true);
        } else {
          setHasMore(false);
        }
      }
    }
  }

  async function filterDoctor(event) {
    event.preventDefault();

    // if (
    //   distance ||
    //   (cities && cities.length) ||
    //   startDate ||
    //   endDate ||
    //   gender
    // ) {
      let payLoad = {
        radius: distance,
        city: cities,
        gender,
        // status: "1",
      };
      if (startDate && endDate) {
        payLoad["start_date"] = startDate;
        payLoad["end_date"] = endDate;
      }

      const response = await doctorAvailabilityByFilter(sId, Id, payLoad);
      // setDoctor(response.data.doctors);

      const doctorsData = [...response.data.doctors].sort((a, b) => 
      {
        return (a.availability === null)-(b.availability === null) || -(a.availability>b.availability)||+(a.availability<b.availability)
      }
      );
      setDoctor(doctorsData);
      setFilterApplied(true);

      setFilterModal(false);
    // } else {
    //   setFilterModal(false);
    // }
  }

  const breadCrumbData = [
    { type: 1, url: `${APP_SUB_FOLDER}/`, name: "Home" },

    {
      type: 1,
      url: location.pathname.startsWith(`${APP_SUB_FOLDER}/book-consult/clinics/`)
        ? `${APP_SUB_FOLDER}/book-consult/clinics`
        : `${APP_SUB_FOLDER}/book-consult/hospitals`,
      name: "Book Consult",
    },
    ...(!location.pathname.startsWith(`${APP_SUB_FOLDER}/book-consult/clinics/`)
      ? [
          {
            type: 1,
            url: `${APP_SUB_FOLDER}/book-consult/hospitals/${
              hospitalInfo ? hospitalInfo.slug : ""
            }/${Id}`,
            name: hospitalInfo ? hospitalInfo.name : "",
          },
        ]
      : []),
    { type: 3, url: "", name: specialityName },
  ];
  
  const resetValues = () => {
    setCities([]);
    setStartDate(null);
    setEndDate(null);
    setGender(0);
    setAvailibilityType("");
    setDistance(null);
    setDoctor(allDoctors);
  };
  
  const [isEarlySlots,setEarlySlots] = useState(false)
  
  const fetchEarliestSlots = ()=>{
    setLoading(true)
    if(Id){
      doctorImmediateAvailability(sId, Id)
      .then(function (response) {
        let res = response.data;
        setEarlySlots(true)
        if (res && res.doctors && res.doctors.data) {
          // setDoctor(res.doctors.data);
          const doctorsData = [...res.doctors.data].sort((a, b) => 
          {
            return (a.availability === null)-(b.availability === null) || -(a.availability>b.availability)||+(a.availability<b.availability)
          }
          );
         setDoctor(doctorsData);
        }
    setLoading(false)

      })
      .catch(function (err) {
    setLoading(false)

      });
    }
  }
  
  return (
    <React.Fragment>
         <Helmet_SEO_META SEO_META={SEO_META} />
      <section>
        <Container>
          <BreadcrumbWithUrl breadcrumbs={breadCrumbData} />
          
          <div className="d-flex align-items-center mt-4">
            <SearchTextWidget
              placeHolder={`Search doctors`}
              btnDisplay={true}
              setKeyword={setKeyword}
              searchClickHandler={searchButtonClick}
            />
            {location.pathname.includes(`/book-consult/hospitals/`)? '':
              <span
                className="mhc-filter-btn"
                onClick={() => {
                  if (!filterApplied) {
                    resetValues();
                  }
                  setFilterModal(true);
                }}
              >
                <img src={`${APP_SUB_FOLDER}${Fliter}`} alt="filter" />
              </span>
            }
          </div>
          <div className="mhc-consult-type d-block d-sm-flex gap-3 gap-lg-0  bd-highlight flex-row  align-items-center mt-4 position-relative ">
            <div className="order-0 order-lg-0">
              <span className="fw-bold ">Consult Type</span>
            </div>
            <div className="order-2 order-lg-0">
              <ul className="list-unstyled mb-0 d-flex align-items-center mt-2 mt-sm-0">
                <li>
                  <div className="form-check mt-1 ms-0 ms-lg-4">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="All"
                      value="0"
                      checked={consultType === "0"}
                      onChange={(e) => setConsultType(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="All">
                      All
                    </label>
                  </div>
                </li>
                <li>
                  <div className="form-check mt-1 ms-3 ms-sm-4">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="Hospital"
                      value="2"
                      checked={consultType === "2"}
                      onChange={(e) => setConsultType(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="Hospital">At Hospital/ Clinic</label>
                  </div>
                </li>
                <li>
                  <div className="form-check mt-1 ms-3 ms-sm-4">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="Virtual"
                      value="1"
                      checked={consultType === "1"}
                      onChange={(e) => setConsultType(e.target.value)}
                    />
                    <label className="form-check-label" htmlFor="Virtual">Virtual </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          {loading ? (
            <>
        
              <LodingComponent className="mhc-Loding-minHeight" />
            </>
          ) : (
            <div className="row mt-4">
              <Doctors
                doctors={doctor}
                consultType={consultType}
                hId={Id}
                sId={sId}
                callingType={location.pathname.startsWith(`${APP_SUB_FOLDER}/book-consult/clinics/`)?'clinics':'hospitals'}
              />
            </div>
          )}
        </Container>
      </section>
  
      <FilterDoctorModal
        filterModal={filterModal}
        values={{
          gender,
          cities,
          startDate,
          endDate,
          distance,
        }}
        onHide={() => {
          setStartDate(null);
          setEndDate(null);
          setFilterModal(false);
        }}
        allCities={allCities}
        listInnerRef={listInnerRef}
        onScroll={() => onScroll()}
        allDistances={allDistances}
        changeDistance={(e, item) => {
          if (e.target.checked) setDistance(item.id)
          else setDistance(null);
        }}
        onAvailibilityChange={(e) => {
          if (e.target.checked) {
            const next2Days = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000);
            setStartDate(dateFormatIntoDDMMYYYY(next2Days));
            setEndDate(dateFormatIntoDDMMYYYY(next2Days));
          }
        }}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        onGenderChange={(e, gender) => {
    
          setGender(gender);
        }}
        closeModal={() => setFilterModal(false)}
        filterDoctor={filterDoctor}
        onCityChange={(e, item) => {
          if (e.target.checked) {
            setCities([...cities, item.id]);
          } else {
            setCities((prevCities) => {
              return prevCities.filter((cityId) => cityId !== item.id);
            });
          }
        }}
        startDate={startDate}
        endDate={endDate}
        availabilityType={availabilityType}
        setAvailibilityType={(type) => {
          setAvailibilityType(type);
        }}
        resetValues={resetValues}
      />
    </React.Fragment>
  );
}
